<circulation-dialog
  [title]="'owner.edit.dialog.title'"
  [content]="'owner.edit.dialog.content'"
  [(opened)]="ownerDialogOpened"
  (dialogClosed)="onEditDialogClosed($event)"
  ></circulation-dialog>

<form class="k-form" [formGroup]="formGroup">
  <fieldset class="k-form-fieldset">
    <legend class="k-form-legend">{{ 'circ_edit_legend' | i18n }}</legend>
    <kendo-formfield *ngIf="circulation.props.status=='InCreation'" showHint="initial" showErrors="initial">
      <kendo-label [for]="title" [text]=" 'circ_new_label_owner' | i18n "></kendo-label>
      <sp-people-picker [maxPeople]="2" formControlName="owner">
      </sp-people-picker>
      <kendo-formhint>{{ 'circ_new_formhint_owner' | i18n }}</kendo-formhint>
      <kendo-formerror>
        <div *ngIf="formGroup.controls.owner.errors?.required">{{ 'circ_new_formerror_owner' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield showHint="initial" showErrors="initial">
      <kendo-label [for]="title" [text]=" 'circ_new_label_title' | i18n "></kendo-label>
      <input kendoTextBox [formControlName]="'title'" #title required />
      <kendo-formhint>{{ 'circ_new_formhint_title' | i18n }}</kendo-formhint>
      <kendo-formerror>
        <div *ngIf="formGroup.controls.title.errors?.required">{{ 'circ_new_formerror_title' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield [showErrors]="'initial'">
      <kendo-label [for]="demand" [text]="'circ_new_label_demand' | i18n"></kendo-label>
      <textarea [className]="'demand'" kendoTextArea [formControlName]="'demand'" #demand required></textarea>
      <kendo-formhint>{{ 'circ_new_formhint_demand' | i18n }}</kendo-formhint>
      <kendo-formerror>
        <div *ngIf="formGroup.controls.demand.errors?.required">{{ 'circ_new_formerror_demand' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield [showErrors]="'initial'">
      <kendo-label [for]="additionalReportRecipients" [text]="'circ_new_label_additionalReportRecipients' | i18n">
      </kendo-label>
      <sp-people-picker #additionalReportRecipients formControlName="recipients">
      </sp-people-picker>
      <kendo-formhint>{{ 'circ_new_formhint_additionalReportRecipients' | i18n }}</kendo-formhint>
      <kendo-formerror>
      </kendo-formerror>
    </kendo-formfield>
    <div class="meta-container">
      <div *ngFor="let d of this.editableMetadata">
        <circ-data [data]="d" [formGroup]="formGroup">
        </circ-data>
      </div>
    </div>
    <div class="k-form-buttons">
      <ece-btn-primary (click)="clickSave()" [text]=" 'circ_new_button_save' | i18n "></ece-btn-primary>
      <ece-btn (click)="clickAbort()" [text]=" 'circ_new_button_abort' | i18n "></ece-btn>
    </div>
  </fieldset>
</form>
